import { render, staticRenderFns } from "./loading-button.vue?vue&type=template&id=773c2f00"
import script from "./loading-button.vue?vue&type=script&lang=js"
export * from "./loading-button.vue?vue&type=script&lang=js"
import style0 from "./loading-button.vue?vue&type=style&index=0&id=773c2f00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports